<div class="d-inline-block w-100 position-relative">
    <div class="float-start col-12">
      <mat-card class="mat-elevation-z0 search-box d-flex align-items-center">
        <mat-label layout-align="center" class="search-select float-start">Property</mat-label>
        <property-search class="search-feild float-start w-100-143" (propertySelected)="onPropertySelect($event)" [isAssetViewClosed]="isAssetViewClosed">
        </property-search>
      </mat-card>
    </div>
  </div>
<div *ngIf="isGetAssetCountByCatergoryLoading">
    <app-common-loader></app-common-loader>
</div>
<div *ngIf="!isGetAssetCountByCatergoryLoading">
    <div class="custom-scroller dashboard-content">
    <div class="no-jobs-indicator d-flex flex-column align-items-center justify-contet-center text-center mt-5 pt-5"
        *ngIf="assetCategoryCount?.needToBeApprovedCount == 0 &&  assetCategoryCount?.duplicatedCount == 0 &&
        assetCategoryCount?.sentToTenantCount == 0 &&  assetCategoryCount?.completedCount == 0 && (property == null || property.id == null)">
        <img src="../../../../assets/images/empty-box-open.png" width="100" />
        <h2 class="font-poppins font-semibold mb-0 mt-5 font-30 mb-3">No assets found!</h2>
    </div>
    <div *ngIf="property?.id != null">
        <app-property-asset [selectedProperty]="property"
            (closeFilteredAssetsByProperty)="closeFilteredAssetsByProperty()"></app-property-asset>
    </div>
    <div *ngIf="property == null || property.id == null">
        <mat-card class="mt-0 mat-elevation-z0 summery-box align-items-center d-flex w-100" *ngIf="assetCategoryCount?.needToBeApprovedCount > 0">
            <div class="float-start col-2 col-xl-1 px-2">
                <img class="mw-100" src="../../../../../assets/images/tobe-approved.svg">
            </div>
            <div class="details float-start col-6 col-xl-9 px-0 px-xl-3">
                <h4 class="mb-0 font-poppins font-20 font-semibold">{{assetCategoryCount.needToBeApprovedCount}} Assets that need to be approved</h4>
            </div>
            <div class="float-start col-4 col-xl-2 d-flex h-100 justify-content-end align-items-center text-end">
                <button class="common-button mat-elevation-z0 black me-2" mat-button mat-raised-button (click)="viewAction('NeedToBeApproved')">View & take action</button>
            </div>      
        </mat-card>

        <mat-card class="mt-3 mat-elevation-z0 summery-box align-items-center d-flex w-100" *ngIf="assetCategoryCount?.duplicatedCount > 0">
            <div class="float-start col-2 col-xl-1 px-2">
                <img class="mw-100" src="../../../../../assets/images/duplicated.svg">
            </div>
            <div class="details float-start col-6 col-xl-9 px-0 px-xl-3">
                <h4 class="mb-0 font-poppins font-20 font-semibold">{{assetCategoryCount.duplicatedCount}} Assets that are duplicated</h4>
            </div>
            <div class="float-start col-4 col-xl-2 d-flex h-100 justify-content-end align-items-center text-end">
                <button class="common-button mat-elevation-z0 black me-2" mat-button mat-raised-button (click)="viewAction('Duplicated')">View & take action</button>
            </div>
        </mat-card>

        <mat-card class="mt-3 mat-elevation-z0 summery-box align-items-center d-flex w-100" *ngIf="assetCategoryCount?.sentToTenantCount > 0">
            <div class="float-start col-2 col-xl-1 px-2">
                <img class="mw-100" src="../../../../../assets/images/tenants.svg">
            </div>
            <div class="details float-start col-6 col-xl-9 px-0 px-xl-3">
                <h4 class="mb-0 font-poppins font-20 font-semibold">{{assetCategoryCount.sentToTenantCount}} Assets pending from tenants</h4>
            </div>
            <div class="float-start col-4 col-xl-2 d-flex h-100 justify-content-end align-items-center text-end">
                <button class="common-button mat-elevation-z0 black me-2" mat-button mat-raised-button (click)="viewAction('SentToTenant')">View & take action</button>
            </div>          
        </mat-card>
    </div>
</div>
</div>
<mat-sidenav-container hasBackdrop="true">
    <mat-sidenav class="secondary-drawer xxl p-0" mode="over" [opened]="openSidebar" position="end"
        [disableClose]="true">
        <button class="drawer-close-btn mat-elevation-z0" (click)="dismiss()" mat-mini-fab aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
        <router-outlet (activate)="openSidebar = true" (deactivate)="openSidebar = false"></router-outlet>
    </mat-sidenav>
</mat-sidenav-container>